import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconsNavigationChevronRight = props => {
  if (props.id !== "_svgiconsnavigationchevronright") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.063 18.335a.897.897 0 001.268 1.269l6.92-6.92a.893.893 0 00.231-.4c.099-.33-.002-.727-.29-1.016L9.45 4.528c-.4-.4-1.009-.44-1.36-.088-.351.351-.312.96.088 1.36l6.21 6.21-6.326 6.325z" fill="#202020" /></svg>;
};

SvgIconsNavigationChevronRight.displayName = "_svgiconsnavigationchevronright";
SvgIconsNavigationChevronRight.propTypes = {
  id: PropTypes.string
};
SvgIconsNavigationChevronRight.defaultProps = {
  id: ''
};
export default SvgIconsNavigationChevronRight;